/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ITransactionFlagTypes {
  CanceledReturnInvestmentEarly = 'canceledReturnInvestmentEarly',
}

export enum ITransactionStatus {
  Confirmed = 'confirmed',
  Cancelled = 'cancelled',
  Pending = 'pending',
}

export enum ITransactionType {
  Credit = 'credit',
  Withdrawal = 'withdrawal',
  Reservation = 'reservation',
  Investment = 'investment',
  PayoutRevenue = 'payoutRevenue',
  PayoutRevenue2 = 'payoutRevenue2',
  PayoutBonus = 'payoutBonus',
  PayoutBonusFixed = 'payoutBonusFixed',
  PayoutPrincipal = 'payoutPrincipal',
  InvestmentTransferOut = 'investmentTransferOut',
  InvestmentTransferIn = 'investmentTransferIn',
  Gift = 'gift',
  PayoutBonusWelcome = 'payoutBonusWelcome',
  BonusAffiliate = 'bonusAffiliate',
  PayoutVipBonus = 'payoutVipBonus',
  GiftPayment = 'giftPayment',
  LoanGranting = 'loanGranting',
  LoanPayment = 'loanPayment',
  InvestmentRevenueFee = 'investmentRevenueFee',
  InvestmentRevenueFeePayment = 'investmentRevenueFeePayment',
  DispoLegacyOut = 'dispoLegacyOut',
  DispoLegacyIn = 'dispoLegacyIn',
  Revenue = 'revenue',
  BonusPrereservation = 'bonusPrereservation',
  BonusLastminute = 'bonusLastminute',
  BonusPrincipal = 'bonusPrincipal',
  BonusWelcome = 'bonusWelcome',
  WithdrawalPrincipal = 'withdrawalPrincipal',
  ReturnReserved = 'returnReserved',
  MarketplaceSold = 'marketplaceSold',
  MarketplaceBought = 'marketplaceBought',
  MarketplaceReservation = 'marketplaceReservation',
  MarketplaceFee = 'marketplaceFee',
}

export enum IProjectCollateralCategory {
  Residential = 'residential',
  Commercial = 'commercial',
  Land = 'land',
  Recreational = 'recreational',
  Other = 'other',
}

export enum IProjectPaymentType {
  WYtH2FcWv8FvnywF9 = 'wYtH2fcWv8fvnywF9',
  NmMQDPs7FbinwaHJo = 'NmMQDPs7fbinwaHJo',
  GqBX9Z6CB9DKdrpY2 = 'GqBX9Z6cB9DKdrpY2',
  IKJoNu4ImSMTZ596D = 'iKJoNu4imSMTZ596D',
  DW52PBdeLbgMmJXci = 'dW52PBdeLbgMmJXci',
  G9GP3ZhJ9P6NRJkRh = 'g9GP3ZhJ9p6nRJkRh',
}

export enum IProjectStatus {
  Created = 'created',
  Preparing = 'preparing',
  Running = 'running',
  CampaignFinished = 'campaignFinished',
  Funded = 'funded',
  Finished = 'finished',
  Cancelled = 'cancelled',
}

export enum IRevenuesFeeStatus {
  Immunity = 'immunity',
  Applied = 'applied',
}

export enum IInvestmentStatus {
  Prereserved = 'prereserved',
  Reserved = 'reserved',
  Invested = 'invested',
  Paid = 'paid',
  PaidEarly = 'paidEarly',
  Cancelled = 'cancelled',
  Withdrawn = 'withdrawn',
  Delayed = 'delayed',
  Extended = 'extended',
}

export enum IPortfolioInvestmentsSortId {
  Id = '_id',
  CreatedAt = 'createdAt',
  TotalYieldPerAnnum = 'totalYieldPerAnnum',
  LatestPaymentDate = 'latestPaymentDate',
  Bonus = 'bonus',
  ProjectCollateralInfoCollateralCategory = 'project.collateralInfo.collateralCategory',
  ProjectLoanPurpose = 'project.loanPurpose',
  Status = 'status',
  Total = 'total',
  Value = 'value',
}

export enum IProjectLoanPurpose {
  Reconstruction = 'reconstruction',
  Construction = 'construction',
  Investment = 'investment',
  Buying = 'buying',
  Business = 'business',
  Purchase = 'purchase',
  Refinancing = 'refinancing',
  Development = 'development',
  Flipping = 'flipping',
}

export enum IProjectCollateralSubcategory {
  Flat = 'flat',
  House = 'house',
  Apartman = 'apartman',
  Office = 'office',
  CommercialSpace = 'commercialSpace',
  Polyfunction = 'polyfunction',
  BuildingLands = 'buildingLands',
  Meadow = 'meadow',
  Garden = 'garden',
  OtherLand = 'otherLand',
  Hotel = 'hotel',
  Pension = 'pension',
  Cottage = 'cottage',
  Accommodation = 'accommodation',
  GasStation = 'gasStation',
  Logistics = 'logistics',
  ManufacturingArea = 'manufacturingArea',
  Warehouse = 'warehouse',
  Garage = 'garage',
  RealEstate = 'realEstate',
  Other = 'other',
}

export interface IUnauthorizedResponse {
  /** @example 401 */
  statusCode: number
  /** @example "Unauthorized" */
  error: string
}

export interface IForbiddenResponse {
  /** @example 403 */
  statusCode: number
  /** @example "Forbidden" */
  error: string
}

export interface IAddBankAccountRequest {
  /** IBAN (medzery/pomlčky sa normalizujú) */
  iban: string
  /** 5-znakový 2FA kód (purpose addBankAccount, data {iban}) */
  twoFACode: string
  /** Musí byť true — user musí byť vlastníkom účtu */
  isOwner: boolean
}

export interface IAddBankAccountOkResponse {
  /** Optional success message */
  message?: string
}

export interface IBadRequestResponse {
  /** @example 400 */
  statusCode: number
  /** @example "Bad Request" */
  error: string
}

export interface IDeleteBankAccountRequest {
  /** IBAN (medzery/pomlčky sa normalizujú) */
  iban: string
}

export interface IDeleteBankAccountOkResponse {
  /** Optional success message */
  message?: string
}

export interface IPortfolioAggregatesDto {
  disponibleFunds: number
  expectedFutureRevenue: number
  remainingInvestedFunds: number
  totalBlockedFunds: number
  totalAccountValue: number
}

export interface IPortfolioAggregatesOkResponse {
  /** Optional success message */
  message?: string
  aggregates: IPortfolioAggregatesDto
}

export interface IPortfolioInvestmentsMinMaxRange {
  min?: number
  max?: number
}

export interface IPortfolioInvestmentsProjectFilter {
  collateralSubcategory?: IProjectCollateralSubcategory[]
  loanPurpose?: IProjectLoanPurpose[]
}

export interface IPortfolioInvestmentsFilter {
  _id?: string
  investmentYears?: number[]
  latestPaymentYears?: number[]
  totalYieldPerAnnum?: IPortfolioInvestmentsMinMaxRange[]
  total?: IPortfolioInvestmentsMinMaxRange[]
  value?: IPortfolioInvestmentsMinMaxRange[]
  project?: IPortfolioInvestmentsProjectFilter
}

export interface IPortfolioInvestmentsSort {
  id?: IPortfolioInvestmentsSortId
  desc?: boolean
}

export interface IPortfolioInvestmentsRequest {
  filter?: IPortfolioInvestmentsFilter
  /** Default 10 */
  limit?: number
  /** Default 0 */
  offset?: number
  sort?: IPortfolioInvestmentsSort
}

export interface IInvestmentPrereservationPlan {
  disponibleFundsFixed: number
  futureRevenueFixed: number
  totalYield: number
  totalYieldPerAnnum: number
  totalFixed: number
}

export interface IInvestmentCommited {
  disponibleFundsFixed: number
  futureRevenueFixed: number
}

export interface IInvestmentPrereservation {
  plan: IInvestmentPrereservationPlan
  committed: IInvestmentCommited
}

export interface IInvestmentRevenueFee {
  status: IRevenuesFeeStatus
  fee?: number
}

export interface IPortfolioInvestmentProjectCollateralInfo {
  collateralCategory?: IProjectCollateralCategory
  collateralSubcategory?: IProjectCollateralSubcategory
}

export interface IPortfolioInvestmentProject {
  _id: string
  stageNumber: number
  businessId: number
  statusId: IProjectStatus
  sign: string
  paymentType: IProjectPaymentType
  /** @format date-time */
  revenuesFlowStartDate: string
  loanPurpose?: IProjectLoanPurpose | null
  location?: string | null
  collateralInfo: IPortfolioInvestmentProjectCollateralInfo
}

export interface IPortfolioInvestmentItem {
  _id: string
  /** @format date-time */
  createdAt: string
  sign: string
  status: IInvestmentStatus
  projectId: string
  withdrawalDisabled?: boolean
  totalYieldPerAnnum: number
  totalYield: number
  period: number
  extendPeriod: number
  prereservationData?: IInvestmentPrereservation
  createdUsingBlurTags?: string[]
  bonus: number
  value: number
  total: number
  revenueFee?: IInvestmentRevenueFee
  isYieldCompoundingAnnually?: boolean
  /** @format date-time */
  latestPaymentDate?: string | null
  /** Netto yield % (po revenue fee) */
  totalCalculatedYield: number
  /** Istina + netto výnos (EUR) */
  totalPrincipalWithYieldValue: number
  /** Nabehnutý compound výnos k dnešku (EUR), null ak sa nepočíta */
  currentCompoundedRevenueValue?: number | null
  project: IPortfolioInvestmentProject
  isWithdrawable: boolean
  nettoBonusValue: number
}

export interface IPortfolioInvestmentsOkResponse {
  /** Optional success message */
  message?: string
  items: IPortfolioInvestmentItem[]
  totalCount: number
}

export interface IPortfolioTransactionsProjectFilter {
  businessId?: number
  stageNumber?: number
}

export interface IPortfolioTransactionsFilter {
  types?: ITransactionType[]
  /** @format date-time */
  startDate?: string
  /** @format date-time */
  endDate?: string
  project?: IPortfolioTransactionsProjectFilter
}

export interface IPortfolioTransactionsRequest {
  filter?: IPortfolioTransactionsFilter
  limit?: number
  offset?: number
}

export interface IPortfolioTransactionProjectCollateralInfo {
  collateralCategory?: IProjectCollateralCategory
  collateralSubcategory?: IProjectCollateralSubcategory
}

export interface IPortfolioTransactionProject {
  _id: string
  stageNumber: number
  businessId: number
  loanPurpose?: IProjectLoanPurpose | null
  collateralInfo?: IPortfolioTransactionProjectCollateralInfo
}

export interface IPortfolioTransactionInvestment {
  _id: string
  sign: string
}

export interface IPortfolioTransactionItem {
  _id: string
  /** @format date-time */
  createdAt: string
  typeId: ITransactionType
  statusId: ITransactionStatus
  walletId: string
  value: number
  flag?: ITransactionFlagTypes
  revenueFeeMonthlyInvoiceCode?: string
  investmentId?: string | null
  projectId?: string | null
  project?: IPortfolioTransactionProject
  investment?: IPortfolioTransactionInvestment
}

export interface IPortfolioTransactionsOkResponse {
  /** Optional success message */
  message?: string
  items: IPortfolioTransactionItem[]
  totalCount: number
}

export interface IWithdrawFundsRequest {
  /** ID investor peňaženky usera */
  walletId: string
  /** IBAN overeného bankového účtu z profilu (medzery/pomlčky sa normalizujú) */
  iban: string
  /** Suma výberu v EUR (max 2 desatinné miesta) */
  amount: number
}

export interface IWithdrawFundsOkResponse {
  /** Optional success message */
  message?: string
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter(
      (key) => 'undefined' !== typeof query[key]
    )
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key)
      )
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`
        )
        return formData
      }, new FormData())
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (
    cancelToken: CancelToken
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      }
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const responseToParse = responseFormat ? response.clone() : response
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data
    })
  }
}

/**
 * @title IIS Account API
 * @version 1.0
 * @contact
 *
 * API for Account (finance)
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  account = {
    /**
     * No description
     *
     * @tags Account Bank Accounts
     * @name BankAccountControllerAdd
     * @summary Add bank account (2FA code required, scoped to the exact IBAN)
     * @request POST:/account/bank-accounts/add
     * @secure
     */
    bankAccountControllerAdd: (
      data: IAddBankAccountRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IAddBankAccountOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/account/bank-accounts/add`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account Bank Accounts
     * @name BankAccountControllerDelete
     * @summary Delete bank account (soft delete; 400 when IBAN not found)
     * @request POST:/account/bank-accounts/delete
     * @secure
     */
    bankAccountControllerDelete: (
      data: IDeleteBankAccountRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IDeleteBankAccountOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/account/bank-accounts/delete`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account Portfolio
     * @name PortfolioControllerGetAggregates
     * @summary Portfolio aggregates summed across all user wallets
     * @request GET:/account/portfolio/aggregates
     * @secure
     */
    portfolioControllerGetAggregates: (params: RequestParams = {}) =>
      this.request<
        IPortfolioAggregatesOkResponse,
        IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/account/portfolio/aggregates`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account Portfolio
     * @name PortfolioControllerGetInvestments
     * @summary Paginated + filtered list of user investments (portfolio tab)
     * @request POST:/account/portfolio/investments
     * @secure
     */
    portfolioControllerGetInvestments: (
      data: IPortfolioInvestmentsRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IPortfolioInvestmentsOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/account/portfolio/investments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account Portfolio
     * @name PortfolioControllerGetTransactions
     * @summary Paginated + filtered list of user transactions (portfolio tab)
     * @request POST:/account/portfolio/transactions
     * @secure
     */
    portfolioControllerGetTransactions: (
      data: IPortfolioTransactionsRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IPortfolioTransactionsOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/account/portfolio/transactions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Account Wallet
     * @name WalletControllerWithdrawFunds
     * @summary Withdraw available funds to a verified bank account (creates WITHDRAWAL transaction)
     * @request POST:/account/withdraw-funds
     * @secure
     */
    walletControllerWithdrawFunds: (
      data: IWithdrawFundsRequest,
      params: RequestParams = {}
    ) =>
      this.request<
        IWithdrawFundsOkResponse,
        IBadRequestResponse | IUnauthorizedResponse | IForbiddenResponse
      >({
        path: `/account/withdraw-funds`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  }
}
